import React from 'react';
import type { VisitorStatus, VisitorType } from '@/data/mockData';

interface StatusBadgeProps {
  status: VisitorStatus;
  size?: 'sm' | 'md';
}

export function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const sizeClass = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-2.5 py-1';

  const config: Record<VisitorStatus, { bg: string; text: string; dot: string }> = {
    'داخل': { bg: 'bg-success/15 border border-success/30', text: 'text-success', dot: 'bg-success' },
    'خرج': { bg: 'bg-muted border border-border', text: 'text-muted-foreground', dot: 'bg-muted-foreground' },
    'منتهية الصلاحية': { bg: 'bg-warning/15 border border-warning/30', text: 'text-warning', dot: 'bg-warning' },
    'ملغاة': { bg: 'bg-danger/15 border border-danger/30', text: 'text-danger', dot: 'bg-danger' },
  };

  const c = config[status];

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-medium ${sizeClass} ${c.bg} ${c.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${c.dot} ${status === 'داخل' ? 'animate-pulse' : ''}`} />
      {status}
    </span>
  );
}

interface TypeBadgeProps {
  type: VisitorType;
  size?: 'sm' | 'md';
}

export function TypeBadge({ type, size = 'md' }: TypeBadgeProps) {
  const sizeClass = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-2.5 py-1';

  const config: Record<VisitorType, { bg: string; text: string }> = {
    'زائر': { bg: 'bg-info/15 border border-info/30', text: 'text-info' },
    'مورد': { bg: 'bg-accent/15 border border-accent/30', text: 'text-accent' },
    'مقاول': { bg: 'bg-warning/15 border border-warning/30', text: 'text-warning' },
    'عميل': { bg: 'bg-secondary border border-border', text: 'text-foreground' },
    'سائق شاحنة': { bg: 'bg-primary/50 border border-primary', text: 'text-foreground' },
    'عامل خارجي': { bg: 'bg-muted border border-border', text: 'text-muted-foreground' },
  };

  const c = config[type] ?? { bg: 'bg-muted border border-border', text: 'text-muted-foreground' };

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${sizeClass} ${c.bg} ${c.text}`}>
      {type}
    </span>
  );
}